// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoSections_videoWrapper__Tq6Ll","videoEmbedWrapper":"VideoSections_videoEmbedWrapper__uSO4W","videoEmbed":"VideoSections_videoEmbed__WVdT7"};